namespace SolovisGateway.Admin.DataEnvironments {

    /**
     * ManageEnvironmentListControl presents the user interface for picking an environment
     * for which we want to manage the list of users. This is *NOT* the same as the list
     * for the "Admin" section list which we purposely keep separate.
     */
    export class ManageEnvironmentListControl extends Solovis.UI.BaseControl {

        private _envList;
        private _initError;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options) {
            super(options);
        }

        public doInitAsync() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "/DataEnvironment/GetEnvironmentList",
                {},
                function (response, success) {
                    if (success) {
                        self._envList = response.result.environments;
                    }
                    else {
                        console.log("ERROR: ManageEnvironmentListControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }

                    self.notifyInitComplete();
                });
        }

        public doRender() {
            let self = this;

            // Setup data grid
            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'id',
                data: this._envList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'subdomain'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },

                width: "100%",

                columns: [
                    {
                        dataField: 'subdomain',
                        dataType: 'string',
                        caption: 'Subdomain',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'description',
                        dataType: 'string',
                        caption: 'Description',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'id',
                        dataType: 'number',
                        caption: 'Data Environment Id',
                        visible: false,
                        allowSorting: true,
                        width: 150
                    },
                    {
                        caption: "Actions",
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            let envData = options.data;
                            self._buildActionsCell(container, envData);
                        },
                        width: 100
                    }
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
        }


        private _buildActionsCell(container, envData) {
            let self = this;
            let columnDiv = container;

            let manageUsersLink = $("<a>").css("padding-left", "5px").appendTo(columnDiv);
            $("<span class='fa fa-user'>").appendTo(manageUsersLink);
            manageUsersLink.attr("title", "Manage Users");
            manageUsersLink.attr(
                "href",
                Solovis.resolveUrl("~/DataEnvironment/ManageUsers?dataEnvironmentId=" + envData.id));
        }

    }

}